import { SHOW_MODAL, CLEAR_MODAL, BROADCAST_JOIN_MEETING } from 'actions/Types';
import { CREATE_MEETING_ERROR } from '@studio/constants';

/**
 * In cases where you need to show a modal, use this state (no longer want to use one-off reducers like 'creatingEvent', etc)
 */
function modal(state = null, action) {
  if (action.type === SHOW_MODAL) {
    return action.payload;
  }

  if (action.type === CLEAR_MODAL) {
    if (state && action.payload === state.type) return null;
  }

  if (action.type === `${BROADCAST_JOIN_MEETING}_FAILURE`) {
    return {
      type: CREATE_MEETING_ERROR,
      errorResponse: action.payload.error.response.data
    };
  }

  return state;
}

export default modal;
